import { AppSidebar } from "../app-sidebar";
import { Footer } from "./footer";
import { Outlet, useLocation } from "react-router-dom";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
  SidebarSeparator,
} from "../ui/sidebar";

export default function AdminPanelLayout() {
  const location = useLocation();

  const getTitle = (path) => {
    if (path.includes("/dashboard")) return "Dashboard";
    if (path.includes("/users")) return "Users";
    if (path.includes("/reports")) return "Reports";
    if (path.includes("/verification")) return "Profile Verification";
    if (path.includes("/analytics")) return "Analytics";
    return "Signova Admin";
  };

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-14 shrink-0 items-center gap-2 border-b bg-background px-4">
          <SidebarTrigger className="-ml-1" />
          <SidebarSeparator orientation="vertical" className="mr-2 h-4" />
          <h1 className="text-base font-semibold text-foreground">
            {getTitle(location.pathname)}
          </h1>
        </header>
        <div className="flex flex-1 flex-col min-h-0 bg-gray-50/50">
          <Outlet />
        </div>
        <Footer />
      </SidebarInset>
    </SidebarProvider>
  );
}
